import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

Vue.use(Vuex)

export const store = new Vuex.Store({
	state: {
        user_token: "",
        user_fullname: "",
        user_username: "",
        system_name: "Webot",
        system_logo: "//assets.office4u.xyz/common_asset/webot_logo.png",
        system_contactus: null,
        registration_flag: false,
        login_flag: false,
        browser_identify: "",
        lang_flag: window.defaultLanguage,
        currency: '',
        services: {
            mini_game_service: 0
        }
	},
	getters: {
        user_token(state) {
            return state.user_token;
        },
        user_username(state) {
            return state.user_username;
        },
        user_fullname(state) {
            return state.user_fullname;
        },
        system_name(state) {
            return state.system_name;
        },
        system_logo(state) {
            return state.system_logo;
        },
        system_contactus(state) {
            return state.system_contactus;
        },
        registration_flag(state) {
            return state.registration_flag;
        },
        login_flag(state) {
            return state.login_flag;
        },
        lang_flag(state) {
            return state.lang_flag;
        },
        browser_identity(state) {
            return state.browser_identify;
        },
        currency(state) {
            return state.currency;
        },
        services(state) {
            return state.services;
        },
	},
	mutations: {
        loginUser(state, obj) {
            state.user_token = obj.access_token;
            state.user_fullname = obj.fullname;
            state.user_username = obj.username;
        },
        logoutUser(state) {
            state.user_token = '';
            state.user_fullname = '';
            state.user_username = '';
        },
        setSystemLogo(state, logo) {
            state.system_logo = logo;
        },
        setSystemContactUs(state, shortcutContact) {
            state.system_contactus = shortcutContact;
        },
        setSystemName(state, name) {
            state.system_name = name;
        },
        toggleRegistrationFlag(state, flag) {
            state.registration_flag = flag;
        },
        toggleLoginFlag(state, flag) {
            state.login_flag = flag;
        },
        toggleLangFlag(state, flag) {
            state.lang_flag = flag;
        },
        setSystemToken(state, token) {
            state.user_token = token;
        },
        setSystemMemberInfo(state, obj) {
            state.user_fullname = obj.fullname;
            state.user_username = obj.username;
        },
        setBrowserIdentity(state, token) {
            state.browser_identify = token;
        },
        setCurrency(state, currency) {
            state.currency = currency;
        },
        setServices(state, services) {
            state.services = services;
        }
	},
	actions: {
        toggleLogin({commit}, flag) {
            commit("toggleLoginFlag", flag);
        },
		login({ commit }, obj) {
			commit("loginUser", obj);
		},
		logout({ commit }) {
			commit("logoutUser");
        },
        setLogo({ commit }, obj) {
			commit("setSystemLogo", obj);
        },
        setContactUs({ commit }, obj) {
			commit("setSystemContactUs", obj);
        },
        setCompanyName({ commit }, obj) {
			commit("setSystemName", obj);
        },
        setLanguage({ commit }, obj) {
			commit("toggleLangFlag", obj);
        },
        setToken({ commit }, obj) {
			commit("setSystemToken", obj);
        },
        setMemberInfo({ commit }, obj) {
            commit("setSystemMemberInfo", obj);
        },
        setBrowserIdentify({ commit }, obj) {
            commit("setBrowserIdentity", obj);
        },
        setSystemCurrency({ commit }, obj) {
            commit("setCurrency", obj);
        },
        setAvailableServices({ commit }, obj) {
            commit("setServices", obj);
        },
    },
    plugins: [vuexLocal.plugin]
})